<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-m_adGroups"></i>广告管理
      <el-tooltip class="item" effect="dark" placement="top">
        <!--  显示的问号  -->
        <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
        <!--  提示插槽      -->
        <div slot="content">
          <p>Tips：异常规则如下：</p>
          <p>7天点击率低于0.05%</p>
          <p>7天曝光量低于200</p>
          <p>7天Acos高于50%</p>
          <p>7天转化率低于5%</p>
        </div>
      </el-tooltip>
    </div>

    <div class="page-content">
      <el-form style="font: bold" :inline="true" label-width="120px" size="small" :model="formInline">
        <el-form-item label="店铺名称：">
          <el-select v-model="formInline.shopId" clearable filterable placeholder="请选择" @change="realChange">
            <el-option v-for="types in dataShops" :key="types.id" :value="types.id" v-text="types.shopName" :label="types.shopName" />
          </el-select>
        </el-form-item>
        <el-form-item label="广告类型：">
          <el-select v-model="formInline.type" style="width: 100%" clearable placeholder="请选择">
            <el-option label="SP" value = "1"/>
            <el-option label="SD" value = "3"/>
          </el-select>
        </el-form-item>
        <el-form-item label="是否异常：">
          <el-select v-model="formInline.normalStatus" style="width: 100%" clearable placeholder="请选择">
            <el-option label="正常" value="0" />
            <el-option label="异常" value="1"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询</el-button>
          <el-button type="primary" @click="authMws" style="backgroundcolor: #2a3861; bordercolor: transparent">去授权</el-button>
          <el-button type="primary" @click="downLoadAdsGroupsFile" style="backgroundcolor: #2a3861; bordercolor: transparent">导出广告</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100vh - 1.45rem)"
        :data="tableData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        style="
            width: 96%;
            margin-top: 10px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
        :cell-style="cellStyle"
      >
        <el-table-column prop="shopName" label="门店名称" width="180" :class-name= "aa" fixed show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="campaignName" label="广告活动名称" width="200" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="impressions" label="展现量" width="100" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="clicks" label="点击量" width="120" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="day7ClickRate" label="点击率" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="orderNum" label="订单量" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="day7Acos" label="ACOS" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="day7ConversionRate" label="转化率" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="type" label="广告类型" width="120" show-overflow-tooltip> 
          <template slot-scope="scope">
            <div v-if="scope.row.type == 1">
              SP
            </div>
            <div v-else>
              SD
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pullStartDay" label="拉取开始时间" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="pullEndDay" label="拉取结束时间" width="120" show-overflow-tooltip> </el-table-column>
      </el-table>
      <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    var user = window.sessionStorage["user"];
    return {
      dataShops: [],
      /*创建角色*/
      addRoleDialog: false,
      modelTitle: "",
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: "",
        description: "",
        authorityIds: [],
      },
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        type: "",
        shopName: "",
        normalStatus: "1",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      Fnupload: {
        id: "",
        businessType: "",
      },
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      dataSites: [],
      flagClick: false
    };
  },
  created() {
    this.getAllDicts();
  },
  methods: {
    cellStyle({row, column, rowIndex, columnIndex}) {
      var str = "text-align:center";
      if (columnIndex === 2 && row.ecpStr.indexOf('2') != -1) {
        str = str + ";background:#d6fed0";
      } else if (columnIndex === 4 && row.ecpStr.indexOf('1') != -1) {
        str = str + ";background:#d6fed0";
      } else if (columnIndex === 6 && row.ecpStr.indexOf('3') != -1) {
        str = str + ";background:#d6fed0";
      } else if (columnIndex === 7 && row.ecpStr.indexOf('4') != -1) {
        str = str + ";background:#d6fed0";
      }
      return str;
    },
    getAllDicts() {
      /*获取所有店铺*/
      this.axios.get("/api/shop/list").then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
          this.getAllSites();
          this.getPreDate();
        }
      });
    },
    getAllSites() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key) {
            if (key.indexOf("1130") == 0) {
              // 站点
              let siteData = data[key];
              siteData.map((item) => {
                item.codeName = item.codeValue + "（" + item.codeName + "）";
              });

              this.dataSites = siteData;
              this.query(); /*绑定树*/
            }
          }
        }
      });
    },
    // 店铺名称选择事件
    realChange(val) {
      console.log(val);
      if(!val){
        // 清空店铺名称
        this.formInline.shopName = '';
      }else{
        var obj = {};
        obj = this.dataShops.find(function(i) {
          return i.id === val;
        });
        this.formInline.shopName = obj.shopName;
      }
    },
    authMws() {
      let baseurl = this.axios.defaults.baseURL;
    },
    downLoadAdsGroupsFile() {
      let baseurl = this.axios.defaults.baseURL;
      let path = '/api/sku-info/export-ad-groups?&type=' + this.formInline.type;
      if (this.formInline.shopName) {
        path += "&shopName=" + this.formInline.shopName;
      }
      if (this.formInline.normalStatus) {
        path += "&normalStatus=" + this.formInline.normalStatus;
      }
      this.axios({
        url: path,
        method: 'get',
        responseType: 'blob',
      }).then(res => {
          console.log('res', res);
          this.downloadCallback(res, '月利润报表.xlsx');
        }
      ).catch(err => {
        console.log(err.message);
      });
      // window.open(path, "_blank");
      // /*加个下载成功的进度条*/
      // setTimeout(() => {
      //   this.$message({
      //     message: "下载成功",
      //     type: "success",
      //     center: true,
      //   });
      // }, 2000);
    },
    downloadCallback(res, fileName) {
      var blob = new Blob([res.data], 
        {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'});
        var download = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        download.style.display = 'none';
        download.href = href;
        download.download =fileName ; //下载后文件名
        document.body.appendChild(download);
        download.click(); //点击下载
        document.body.removeChild(download); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      this.$data.tableData = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.$data.total = resp.data.data.total;
    },
    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },
    getPreDate() {
      var cur = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      //var result = cur.getFullYear() + "-" + this.checkMonth(cur.getMonth()) + '-' + this.checkMonth(cur.getDate());
      return moment(cur).format("YYYY-MM-DD");
    },
    checkMonth(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      // if (this.formInline.pulldate != null && this.formInline.pulldate != "" && this.formInline.pulldate != undefined) {
      //   o.pulldate = moment(this.formInline.pulldate).format("YYYY-MM-dd");
      // } else {
      //   delete o.pulldate;
      // }
      this.axios
        .get("/api/sku-info/page-ad-groups", {
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    }
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #d2e2aa;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form {
      width: 100%;
      height: 36px;
      line-height: 36px;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #e4653a;// #e4653a
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}
</style>
